import { useState, useEffect } from 'react';

const useSafariDetection = () => {
    const [isSafari, setIsSafari] = useState(false);

    useEffect(() => {
        const ua = navigator.userAgent.toLowerCase();
        const safari = ua.indexOf('safari') !== -1 &&
            ua.indexOf('chrome') === -1 &&
            ua.indexOf('android') === -1;
        setIsSafari(safari);
    }, []);

    return isSafari;
}


export default useSafariDetection;
